import { render, staticRenderFns } from "./producao.vue?vue&type=template&id=7a0cda72&scoped=true"
import script from "./producao.vue?vue&type=script&lang=ts"
export * from "./producao.vue?vue&type=script&lang=ts"
import style0 from "./producao.vue?vue&type=style&index=0&id=7a0cda72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0cda72",
  null
  
)

export default component.exports